import axios from 'axios'

export const state = {
  contracts: null,
}

export const getters = {
  contracts: (state) => state.contracts,
}

export const mutations = {
  SET_CONTRACTS(state, contracts) {
    state.contracts = contracts
  },
}

export const actions = {
  fetchAllContracts({ commit }, userId) {
    return axios.get(`/api/users/${userId}/contracts`).then((response) => {
      const contracts = response.data
      commit('SET_CONTRACTS', contracts)
      return contracts
    })
  },

  deleteContract(_, { userId, id }) {
    return axios.delete(`/api/users/${userId}/contracts/${id}`)
  },
}
